/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Top_LeftInputs */

const en_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Left`)
};

const fr_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut Gauche`)
};

const de_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben links`)
};

const it_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In alto a sinistra`)
};

const ru_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вверху слева`)
};

const es_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriba a la izquierda`)
};

const zh_cn2_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左上`)
};

const ja_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左上`)
};

const hi_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाएं से बाएं`)
};

const pt_pt2_input_position_top_left = /** @type {(inputs: Input_Position_Top_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto superior esquerdo`)
};

/**
* | output |
* | --- |
* | "Top Left" |
*
* @param {Input_Position_Top_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_top_left = /** @type {((inputs?: Input_Position_Top_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Top_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_top_left(inputs)
	if (locale === "de") return de_input_position_top_left(inputs)
	if (locale === "it") return it_input_position_top_left(inputs)
	if (locale === "ru") return ru_input_position_top_left(inputs)
	if (locale === "es") return es_input_position_top_left(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_top_left(inputs)
	if (locale === "ja") return ja_input_position_top_left(inputs)
	if (locale === "hi") return hi_input_position_top_left(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_top_left(inputs)
	return en_input_position_top_left(inputs)
});